if (!customElements.get('material-comparison-playground')) {
  customElements.define(
    'material-comparison-playground',
    class MaterialComparisonPlayground extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-material-tab]'));
        this.visual = this.querySelector('[data-material-visual]');
        this.layerLabel = this.querySelector('[data-layer-label]');
        this.coreMark = this.querySelector('[data-core-mark]');
        this.abortController = new AbortController();

        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab), { signal: this.abortController.signal });
          tab.addEventListener('keydown', (event) => this.onKeydown(event, index), {
            signal: this.abortController.signal
          });
        });
      }

      disconnectedCallback() {
        this.abortController?.abort();
      }

      select(tab) {
        this.tabs.forEach((item) => item.setAttribute('aria-pressed', String(item === tab)));
        if (this.visual) this.visual.dataset.mode = tab.dataset.materialTab;
        if (this.layerLabel) this.layerLabel.textContent = tab.dataset.layer;
        if (this.coreMark) this.coreMark.textContent = tab.dataset.core;
      }

      onKeydown(event, currentIndex) {
        let targetIndex = currentIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          targetIndex = (currentIndex + 1) % this.tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          targetIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        } else if (event.key === 'Home') {
          targetIndex = 0;
        } else if (event.key === 'End') {
          targetIndex = this.tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        const target = this.tabs[targetIndex];
        this.select(target);
        target.focus();
      }
    }
  );
}
